import { render, staticRenderFns } from "./IconCaret.vue?vue&type=template&id=94f639b2&scoped=true&"
import script from "./IconCaret.vue?vue&type=script&lang=js&"
export * from "./IconCaret.vue?vue&type=script&lang=js&"
import style0 from "./IconCaret.vue?vue&type=style&index=0&id=94f639b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f639b2",
  null
  
)

export default component.exports